import "./header.css"

export default function Header() {
  return (
    <div className="header">
        <img 
        className="headerImage" 
        src="https://wallpapers.com/images/hd/professional-web-developer-working-on-a-code-setup-j8ljvi05wloqs3ii.jpg" 
        alt="computer pic" />
    </div>
  );
}
